import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import { TextField, InputLabel, Box } from "@mui/material";

interface RHFTextFieldOutlinedProps {
  name: string;
  label?: string;
  placeholder?: string;
  multiline?: boolean;
  minRows?: number;
  required?: boolean;
  [key: string]: any;
}

export const RHFTextFieldOutlined = React.memo(({
  name,
  label,
  placeholder,
  multiline,
  minRows,
  required,
  ...other
}: RHFTextFieldOutlinedProps) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <Box sx={{ width: '100%' }}>
          {label && (
            <InputLabel
              sx={{
                color: '#222B45',
                fontFamily: 'Inter, sans-serif',
                fontWeight: '400',
                fontSize: '15px',
                marginBottom: '8px',
                display: 'block',
              }}
            >
              {label}
              {required && (
                <Box component="span" sx={{ color: '#FF0000', ml: 0.5 }}>
                  *
                </Box>
              )}
            </InputLabel>
          )}
          <TextField
            {...field}
            sx={{
              '& .MuiOutlinedInput-root': {
                height: multiline ? 'auto' : '40px',
                borderRadius: '8px',
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#C8CEE3 !important',
                  borderRadius: '8px',
                  borderWidth: '1px !important',
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#C8CEE3 !important',
                },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#C8CEE3 !important',
                  borderWidth: '1px !important',
                },
                '&.Mui-error .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#FF0000 !important',
                },
              },
              '& .MuiOutlinedInput-input': {
                padding: '4px 14px',
                fontSize: '15px',
                color: '#4E556A',
                '&::placeholder': {
                  color: '#A7AAB5',
                  opacity: 1,
                },
              },
            }}
            fullWidth
            placeholder={placeholder}
            multiline={multiline}
            minRows={minRows}
            error={!!error}
            helperText={error?.message}
            {...other}
          />
        </Box>
      )}
    />
  );
});

